import { useLocation, Navigate } from "react-router-dom";
// material
import { styled } from '@mui/material/styles';
import { Stack, Container, Card, Typography } from '@mui/material';
// components
import Page from '../../../components/Page';
import ClientMaster from '../../../components/SidebarMenuComponents/MasterComponent/ClientMaster'
import ClientInstallationComponent from "../../../components/SidebarMenuComponents/MasterComponent/ClientInstallationComponent";
import Scrollbar from "../../../components/Scrollbar";
import StickyHeader from "../../../components/Common/StickyHeader"
// ----------------------------------------------------------------------------------------------
const ContentStyle = styled('div')(({ theme }) => ({

    margin: 'auto',
    display: 'flex',
    flexDirection: 'column',
}));
export default function ClientInstallationDetailsPage() {
    const location = useLocation();

    const mode = location.state?.mode || "add";
    const rawData = location.state?.clientInstallationData;

    const clientInstallationData = Array.isArray(rawData) ? rawData[0] || {} : rawData || {};

    const titleMap = {
        edit: "Edit Details",
        view: "View Details",
        add: "Add New Details",
    };


    return (
        <Page title="Client Installation Locations | tiketic">
            <StickyHeader title={titleMap[mode] || "Add New Details"} />

            <ContentStyle>
                <ClientInstallationComponent clientInstallationData={clientInstallationData} mode={mode} />
            </ContentStyle>
        </Page>
    );
}


